import { render, staticRenderFns } from "./workManage.vue?vue&type=template&id=46bf967e&"
import script from "./workManage.vue?vue&type=script&lang=js&"
export * from "./workManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports